import {Subscription} from "rxjs";
import {WebsocketService} from "../../websocketService";
import {IMessage} from "@stomp/rx-stomp";
import {Injector} from "@angular/core";
import {AbstractProgressHandler} from "./abstract-progress-handler";
import {WebsocketProgressHandlerConfig,websocketProgressHandlerDefaultConfig} from "./ProgressHandlerFactory";
import {Progression} from "@domain/progression/progression";

/**
 * Handler de suivi de l'avancement d'un traitement back avec une connexion de type Websocket
 *
 * @author Laurent Convert
 * @date 06/08/2025
 */
export class WebsocketProgressHandler extends AbstractProgressHandler {
	/** Configuration du handler */
	private readonly config: WebsocketProgressHandlerConfig;

	/** Souscription de l'abonnement au topic */
	private topicSubscription: Subscription;

	/** Service de connexion à la websocket */
	private webSocketService: WebsocketService;

	/**
	 * Constructeur
	 *
	 * @param config Configuration du handler
	 * @param injector Injecteur Angular
	 */
	constructor(config: WebsocketProgressHandlerConfig,injector: Injector) {
		super();

		//Initialisation
		this.config = Object.assign({},websocketProgressHandlerDefaultConfig,config);
		this.webSocketService = injector.get(WebsocketService);
	}

	/**
	 * Ouverture de la websocket et abonnement au topic permettant de récupérer la progression envoyée par le back
	 *
	 * @param uuid Identifiant de la progression en cours
	 */
	start(uuid: string): void {
		let progression: Progression;

		//Établissement de la connexion websocket
		this.webSocketService.activate();

		//Abonnement au topic
		this.topicSubscription = this.webSocketService
			.watch({destination: this.config.destination,subHeaders: {'uuid': uuid}})
			.subscribe((message: IMessage) => {
				if (!!message?.body) {
					//Récupération et conversion du résultat à partir du JSON recçu
					progression = JSON.parse(message.body);

					//Vérification du uuid reçu
					if (progression?.uuid == uuid) {
						//Mise à jour de l'avancement
						this.update(progression);
					}
				}
			});

		//Envoi de la progression
		this.emitProgress();
	}

	/**
	 * Désabonnement au topic et fermeture de la websocket
	 */
	stop(): void {
		//Désabonnement du topic
		this.topicSubscription?.unsubscribe();

		//Déconnexion Websocket
		this.webSocketService.deactivate();
	}
}